import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
  onClick?: () => void;
}
export function Button({
  children,
  className = '',
  href,
  onClick,
  ...props
}: ButtonProps) {
  const sharedClasses = `
    bg-amber-500 hover:bg-amber-400 text-night-900 
    font-bold py-4 px-8 rounded-md shadow-glow hover:shadow-glow-lg 
    transition-all duration-300 uppercase tracking-wider text-sm sm:text-base
    inline-block text-center no-underline cursor-pointer
    ${className}
  `;
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" onClick={onClick} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={sharedClasses} data-id="element-14">
        {children}
      </motion.a>;
  }
  return <motion.button onClick={onClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={sharedClasses} {...props} data-id="element-15">
      {children}
    </motion.button>;
}